/**
 * EmployeeTypeService
 * Service for EmployeeType entity operations
 * Route: api/employeetypes
 */
import { CrudService } from '../base/CrudService';
/**
 * EmployeeTypeService
 * Handles employee type CRUD operations
 */
export class EmployeeTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EmployeeTypeService.DEFAULT_SERVICE_PATH,
            basePath: EmployeeTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
EmployeeTypeService.DEFAULT_SERVICE_PATH = 'hr';
EmployeeTypeService.BASE_PATH = 'api/employeetypes';
//# sourceMappingURL=EmployeeTypeService.js.map